import React, { useEffect, useState } from "react";
import box from "../../assets/icons/box.webp";
import flowerImg3 from "../../assets/icons/flowerImg3.webp";
import InventoryTable from "../../components/inventory/InventoryTable";
import CommonTitle from "../../components/CommonTitle";
import Filters from "../../components/Filters";
import TableStructure from "../../components/TableScruture";
import FilterItem from "../../components/FilterItem";
import { MdAdd, MdCategory } from "react-icons/md";
import { HiOutlineUpload } from "react-icons/hi";
import ModalStructure from "../../components/ModalStructure";
import ProductForm from "../../components/inventory/ProductForm";
import {
  getImages,
  getProducts,
  getProductsFiltered,
  getTutorials,
} from "../../services/products";
import LoadingPage from "../../components/LoadingPage";
import { IS_LOCAL_ENV, TEST_ENV } from "../../App";
import InDevelopment from "../InDevelopment";
import {
  getAllSubClasses,
  getProductClasses,
} from "../../services/productClass";
import SelectLoad from "../../components/inventory/modals/SelectLoad";
import Notification from "../../components/ui-elements/Notification";

const Inventory = () => {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showSelectModal, setShowSelectModal] = useState(false);
  const [subClassesOptions, setSubClassesOptions] = useState([]);
  const [subClasses, setSubClasses] = useState([]);

  useEffect(() => {
    const fetchAllSubClasses = async () => {
      try {
        const { docs } = await getAllSubClasses();
        setSubClasses(docs);
        setSubClassesOptions(
          docs.map((sc) => ({ text: sc.name, value: sc.id }))
        );
      } catch {
        console.log("error");
        Notification({
          title: "Error",
          text: "Algo salió mal...",
          type: "Error",
        });
      }
    };
    fetchAllSubClasses();
  }, []);

  useEffect(() => {
    setSelectPropsList((prev) =>
      prev.map((prop) =>
        prop.dbField === "subClass"
          ? { ...prop, options: subClassesOptions }
          : prop
      )
    );
  }, [subClassesOptions]);

  //==================filtros===========================
  const [loadingFilter, setLoadingFilter] = useState(false);

  const [selectPropsList, setSelectPropsList] = useState([
    {
      //equal
      isInput: true,
      title: "Código",
      value: "",
      onChange: (e) => updateSelectProp(0, e),
      placeholder: "Buscar código",
      inputType: "text",
      formatedValue: (val) => val,
      dbField: "code",
    },
    {
      //equal
      options: subClassesOptions,
      title: "SubClase",
      value: "",
      setValue: (e) => updateSelectProp(1, e),
      formatedValue: (val) => val,
      dbField: "subClass",
    },
    {
      //greater than
      isInput: true,
      title: "Fecha de ingreso(desde)",
      value: "",
      onChange: (e) => updateSelectProp(2, e),
      inputType: "date",
      formatedValue: (val) => new Date(val).toISOString().split("T")[0],
      dbField: "entryDate",
    },
    {
      //greater than
      isInput: true,
      title: "Precio de venta(desde)",
      value: "",
      onChange: (e) => updateSelectProp(3, e),
      inputType: "number",
      customMaxW: "max-w-[180px]",
      formatedValue: (val) => parseFloat(val),

      dbField: "salePrice",
    },
    {
      //greater than
      isInput: true,
      title: "Precio de compra(desde)",
      value: "",
      onChange: (e) => updateSelectProp(4, e),
      inputType: "number",
      customMaxW: "max-w-[180px]",
      formatedValue: (val) => parseFloat(val),

      dbField: "purchasePrice",
    },
    {
      //equal
      options: [
        { value: "available", text: "Disponible" },
        { value: "unavailable", text: "No disponible" },
        { value: "reserved", text: "Reservado" },
        { value: "sold", text: "Vendido" },
        { value: "other", text: "Otro" },
      ],
      title: "Estado",
      value: "",
      setValue: (e) => updateSelectProp(5, e),
      formatedValue: (val) => val,
      dbField: "status",
    },
  ]);

  const updateSelectProp = (i, e) => {
    setSelectPropsList((prev) => {
      let temp = [...prev];
      temp[i].value = e.target.value;
      return temp;
    });
  };

  const [filterQueryObject, setFilterQueryObject] = useState({});

  //==============================================================
  const [products, setProducts] = useState([]);
  //==========sort prop==========================
  const [sortedProp, setSortedProp] = useState(null); //ej "name" o "-name"
  const [showTableLoader, setShowTableLoader] = useState(false);
  //=========pagination props====================
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  //======================fetch data=======================

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setShowTableLoader(true);
        const { totalPages, docs } = await getProductsFiltered(
          sortedProp,
          currentPage,
          filterQueryObject
        );
        setProducts(docs);
        setTotalPages(totalPages);
        setLoading(false);
        setShowTableLoader(false);
      } catch (error) {
        setLoading(false);
        setShowTableLoader(false);
        IS_LOCAL_ENV && console.log(error);
      }
    };
    fetchProducts();
  }, [currentPage, sortedProp, filterQueryObject]);

  const applyFilters = () => {
    let temp = [];

    temp = selectPropsList
      .filter((filter) => filter.value != "")
      .map((filter) => {
        if (["code", "subClass", "status"].includes(filter.dbField)) {
          return {
            [filter.dbField]: {
              equals: filter.formatedValue(filter.value),
            },
          };
        } else if (
          ["entryDate", "salePrice", "purchasePrice"].includes(filter.dbField)
        ) {
          return {
            [filter.dbField]: {
              greater_than_equal: filter.formatedValue(filter.value),
            },
          };
        }
      });

    let dt = selectPropsList[2].value;
    if (dt != "") {
      const baseDate = new Date(dt);
      baseDate.setUTCHours(0, 0, 0, 0);
      const utcDate = new Date(baseDate.getTime() + 5 * 60 * 60 * 1000);
      temp.push({
        entryDate: {
          greater_than_equal: utcDate.toISOString(),
        },
      });
    }

    const filterQuery =
      temp.length > 1 ? { and: temp } : temp.length === 1 ? temp[0] : {};

    setFilterQueryObject(filterQuery);
  };

  // const clearFilters = () => {
  //   let temp = selectPropsList.map((filter) => {
  //     return { ...filter, value: "" };
  //   });
  //   setSelectPropsList(temp);
  //   applyFilters();
  // };

  //===========================================
  const loadToParent = (newObj, prevId) => {
    let temp = [...products];
    if (!prevId) {
      temp.push(newObj);
      setProducts(temp);
    } else {
      const prevIndex = temp.findIndex((obj) => obj.id == prevId);
      if (prevIndex == -1) return;
      temp[prevIndex] = newObj;
      setProducts(temp);
    }
  };

  const bulkLoadToParent = (newObjs) => {
    let temp = [...products];
    newObjs.forEach((obj) => {
      temp.push(obj);
    });
    setProducts(temp);
  };

  //=============================================
  //if (!IS_LOCAL_ENV) return <InDevelopment />;
  //else

  const uploadParentSC = (newSc) => {
    let temp = [...subClasses];
    let idx = temp.findIndex((sc) => sc.id == newSc.id);
    if (idx == -1) return;
    temp[idx] = newSc;
    setSubClasses(temp);
  };

  return (
    <div className="flex flex-col w-full h-full">
      <CommonTitle
        img={box}
        title="Inventario de productos"
        text={
          "Visualiza y administra cada producto disponible dentro del sistema."
        }
      >
        <div className="flex flex-wrap w-fit">
          <button
            className={` w-fit bg-dark-green text-base m-1 rounded-full py-4 px-6 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins `}
            onClick={() => setShowModal(true)}
          >
            <div className="flex flex-row items-center">
              <span className="text-nowrap">Crear </span>
              <MdAdd />
            </div>
          </button>
          {showModal && (
            <ModalStructure
              customMaxW={"max-w-[1280px]"}
              handleCloseModal={() => setShowModal(false)}
            >
              <ProductForm
                handleClose={() => setShowModal(false)}
                loadToParent={loadToParent}
                subClasses={subClasses}
                uploadParentSC={uploadParentSC}
              />
            </ModalStructure>
          )}
          <button
            className={` w-fit bg-dark-green text-base m-1 rounded-full py-4 px-6 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins `}
            onClick={() => setShowSelectModal(true)}
          >
            <div className="flex flex-row items-center">
              <span className="text-nowrap">Cargar </span>
              <HiOutlineUpload />
            </div>
          </button>
          {showSelectModal && (
            <ModalStructure
              //customMaxW={"max-w-[1280px]"}
              handleCloseModal={() => setShowSelectModal(false)}
            >
              <SelectLoad
                handleClose={() => setShowSelectModal(false)}
                bulkLoadToParent={bulkLoadToParent}
              />
            </ModalStructure>
          )}
        </div>
      </CommonTitle>
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          <Filters applyFilters={applyFilters}>
            {!loadingFilter &&
              selectPropsList.map((props, i) => {
                return <FilterItem props={props} key={i} />;
              })}
          </Filters>

          <TableStructure
            showTableLoader={showTableLoader}
            subClasses={subClasses}
            paginationProps={{ currentPage, setCurrentPage, totalPages }}
          >
            <InventoryTable
              _data={products}
              updateSortedProp={(str) => setSortedProp(str)}
              subClasses={subClasses}
              uploadParentSC={uploadParentSC}
            />
          </TableStructure>
        </>
      )}
    </div>
  );
};

export default Inventory;
